export type FrontendStatusEnum =
    'not_existing'
    | 'created'
    | 'sending'
    | 'sending_successful'
    | 'sending_confirmed'
    | 'sending_error'
    | 'sending_finalized';

export const FrontendStatusEnum = {
    NotExisting: 'not_existing' as FrontendStatusEnum,
    Created: 'created' as FrontendStatusEnum,
    Sending: 'sending' as FrontendStatusEnum,
    SendingSuccessful: 'sending_successful' as FrontendStatusEnum,
    SendingConfirmed: 'sending_confirmed' as FrontendStatusEnum,
    SendingError: 'sending_error' as FrontendStatusEnum,
    SendingFinalized: 'sending_finalized' as FrontendStatusEnum
};

